const getters = {
  isMobile: state => state.app.isMobile,
  lang: state => state.app.lang,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  nickname: state => state.user.name,
  welcome: state => state.user.welcome,
  roles: state => state.user.roles,
  userInfo: state => state.user.info,
  multiTab: state => state.app.multiTab,
  menus: state => state.user.menus,
  lineListEnum: state => state.line.lineListEnum,
  lineListNewEnum: state => state.line.lineListNewEnum,
  lineListTreeEnum: state => state.line.lineListTreeEnum,
}

export default getters
